// Sections the eligible measure list for a chart tool's dropdown by
// provenance so the user can tell at a glance whether a measure is
// already on their table, was suggested by the chart preset, or
// they added it at runtime via the measure picker dialog.
//
// Tools call this with:
//   measureOptions: Array<{ id, label, ... }>   // already filtered to eligible
//   viewIds:        Set<string> | Iterable<string>   // ids in config.columns
//   suggestedIds:   Set<string> | Iterable<string>   // ids from catalog payload
//   userIds:        Set<string> | Iterable<string>   // ids the user added at runtime
//
// Returns the three sections in a stable order. Sections with no
// options are left in (with `options: []`) so callers can decide
// whether to render an empty header; MeasureDropdown filters them
// out by default. An option's "highest precedence" bucket wins:
//   view > suggested > added > unknown
// so a column that's both in the view AND injected by the catalog
// shows up under "In this view" only.

function toSet (iterable) {
  if (!iterable) return new Set()
  if (iterable instanceof Set) return iterable
  return new Set(iterable)
}

export const MEASURE_SECTION_TITLES = Object.freeze({
  view: 'In this view',
  suggested: 'Suggested',
  added: 'Added'
})

export function buildMeasureSections ({ measureOptions, viewIds, suggestedIds, userIds } = {}) {
  const viewSet = toSet(viewIds)
  const suggestedSet = toSet(suggestedIds)
  const userSet = toSet(userIds)
  const inView = []
  const suggested = []
  const added = []
  for (const opt of measureOptions || []) {
    if (viewSet.has(opt.id)) inView.push(opt)
    else if (suggestedSet.has(opt.id)) suggested.push(opt)
    else if (userSet.has(opt.id)) added.push(opt)
    else suggested.push(opt) // unknown provenance -> default to "Suggested" so it stays reachable
  }
  return [
    { title: MEASURE_SECTION_TITLES.view, options: inView },
    { title: MEASURE_SECTION_TITLES.suggested, options: suggested },
    { title: MEASURE_SECTION_TITLES.added, options: added }
  ]
}
